import clsx from 'clsx';
/** Thin `clsx` re-export under the project's conventional short name. */
export function cn(...inputs) {
    return clsx(...inputs);
}
